import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyGLCode = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        if(props.transactionType){
            setloading(true)
            ReadAxios({
                url: 'getGLCode' , readItems : {transactionType : props.transactionType}
            })
                .then((result) => {
                    if(result?.data?.resultSet?.length){
                        setcontent(result.data.resultSet)
                        if(props.transactionType === 'SO' || props.transactionType === 'STO' || props.transactionType === 'PO') setFieldValue(name, result.data.resultSet[0].glCode)
                    }
                    setloading(false)
                })
        }
    }, [props.transactionType])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.id
            temp.text = `${object.glCode}`
            temp.value = object.glCode
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MyGLCode